import { useEffect, useState } from 'react';
import { fetchOwners } from '../services/AISystemsService';
import { Owner } from '../types/AISystems.types';

export const useOwners = () => {
  const [owners, setOwners] = useState<Owner[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadOwners = async () => {
      setLoading(true);
      setError(null);
      try {
        const ownersData = await fetchOwners();
        setOwners(ownersData);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch owners');
      } finally {
        setLoading(false);
      }
    };

    loadOwners();
  }, []);

  return { owners, loading, error };
};